import * as React from 'react';
import { IUser } from '../components/pages/Profile/api';

export const InitUser: IUser = {
    id: 0,
    name: '',
    country: 'US',
    windowsId: '',
}

export interface IUserHook {
    user: IUser;
    setUser: (user: IUser) => void;
}

export const InitHook: IUserHook = {
    user: InitUser,
    setUser: (user: IUser) => void 0,
}

export default React.createContext<IUserHook>(InitHook);